// src/App.jsx
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import ProtectedRoute from "./helper/ProtectedRoute";
import { ToastHost } from "./components/ui/Toast";
import MasterLayout from "./masterLayout/MasterLayout";

// Pages
import SignInPage from "./pages/Authentication/SignInPage";
import OverviewPage from "./pages/Overview/OverviewPage";
import ThreadsPage from "./pages/Threads/ThreadsPage";
import ThreadDetailPage from "./pages/Threads/ThreadDetailPage";
import DirectChatsPage from "./pages/DirectChats/DirectChatsPage";
import DirectChatDetailPage from "./pages/DirectChats/DirectChatDetailPage";
import IdentitiesPage from "./pages/Identities/IdentitiesPage";
import PersonPage from "./pages/Identities/PersonPage";
import ClientsPage from "./pages/Clients/ClientsPage";
import ClientDetailPage from "./pages/Clients/ClientDetailPage";
import UsersPage from "./pages/Users/UsersPage";
import UserPage from "./pages/Users/UserPage";
import ProfilePage from "./pages/Profile/ProfilePage";
import ErrorPage from "./pages/ErrorPage";

/**
 * Routes.
 *
 * The ERP this panel's UI comes from had 139 of them across nineteen
 * departments; MySuhbat administers one thing, so this file is deliberately
 * short and is meant to stay that way. The four sections it will grow --
 * overview, discussions, client systems and people -- are added one at a time
 * as each page is built, not stubbed out in advance.
 */
function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      {/* Outside <Routes> so a toast survives the navigation that raised it. */}
      <ToastHost />

      <Routes>
        {/* Public */}
        <Route path="/sign-in" element={<SignInPage />} />

        {/* Everything else sits inside the shell, behind the guard */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MasterLayout />
            </ProtectedRoute>
          }
        >
          {/* Child pages render inside <Outlet /> */}
          <Route index element={<OverviewPage />} />
          <Route path="muhokamalar" element={<ThreadsPage />} />
          <Route path="muhokamalar/:id" element={<ThreadDetailPage />} />
          {/* P2P chats from the app: staff only, read-only (2026-10-07). */}
          <Route path="shaxsiy-suhbatlar" element={<DirectChatsPage />} />
          <Route path="shaxsiy-suhbatlar/:id" element={<DirectChatDetailPage />} />
          <Route path="shaxslar" element={<IdentitiesPage />} />
          <Route path="shaxslar/:id/:tab?" element={<PersonPage />} />
          <Route path="mijoz-tizimlari" element={<ClientsPage />} />
          {/* One route with an optional tab, so switching tabs keeps the page
              mounted instead of reloading the client. */}
          <Route path="mijoz-tizimlari/:id/:tab?" element={<ClientDetailPage />} />
          <Route path="foydalanuvchilar" element={<Navigate to="/foydalanuvchilar/panel" replace />} />
          <Route path="foydalanuvchilar/panel" element={<UsersPage kind="staff" />} />
          <Route path="foydalanuvchilar/kabinet" element={<UsersPage kind="client" />} />
          <Route path="foydalanuvchilar/panel/:id/:tab?" element={<UserPage kind="staff" />} />
          <Route path="foydalanuvchilar/kabinet/:id/:tab?" element={<UserPage kind="client" />} />
          <Route path="profil" element={<ProfilePage />} />

          <Route path="*" element={<ErrorPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
